/* eslint-disable */
import config from '../../config'
import styles from './index.module.scss'
import PageTitle from '../../components/core/pageTitle'
import Breadcrumb from '../../components/core/breadcrumb'
import { Button } from '../../components/core/button'
import { useLocation, useParams } from 'react-router-dom'
import { useContext, useState, useEffect } from 'react'
import { Calendar, Call, Map } from '../../icons'
import Helper from '../../utils/Helper'
import translate from '../../utils/translate.json'
import Loading from '../../components/pages/loading'
import CareersAPI from '../../api/careers'
import { PageContext } from '../../context/PageContextProvider'

const CareersInternal = ({ className }) => {
  const { language } = useContext(PageContext)
  const location = useLocation()
  const [data, setData] = useState([])
  const [load, setLoad] = useState(false)
  const [crumbs, setCrumbs] = useState([])
  let { id } = useParams()
  useEffect(() => {
    (async () => {

    const { data } = await CareersAPI.getVacancyById(id)
    setData(data)
    setCrumbs([
      {
        link: '/',
        text: {
          AZ: 'Ana Səhifə',
          ENG: 'Home',
          RU: 'Главная страница',
          TR: 'Ana Sayfa',
        },
      },
      {
        link: '/careers',
        text: {
          AZ: 'Karyera',
          ENG: 'Careers',
          RU: 'Карьера',
          TR: 'Kariyer',
        },
      },
      {
        link: location.pathname,
        text:
          data.cardType === 'vacancy'
            ? translate.vacancy
            : translate.internship,
      },
      {
        link: location.pathname,
        text: {
          AZ: Helper.textLengthChecker(data.title['AZ'] || '', 18),
          ENG: Helper.textLengthChecker(data.title['ENG'] || '', 18),
          RU: Helper.textLengthChecker(data.title['RU'] || '', 18),
          TR: Helper.textLengthChecker(data.title['TR'] || data.title['AZ'] || '', 18),
        },
      },
    ])
    setLoad(true)
  
    })();
  }, [id])
  const linkBuilder = (url) => {
    if (!url) return ''
    if (url.startsWith('http://') || url.startsWith('https://')) return url
    return `${config.API_URL}${url.startsWith('/') ? '' : '/'}${url}`
  }
  return load ? (
    <section className={`${className} ${styles.container}`}>
      <Breadcrumb crumbs={crumbs} />
      <div className={styles.content}>
        <div className={styles.main}>
          <figure
            style={{
              backgroundImage: `url('${linkBuilder(data?.photoLocation)}')`,
            }}
          />
          <PageTitle>{data.title?.[language] || data.title?.TR || data.title?.AZ || ''}</PageTitle>
          <p
            dangerouslySetInnerHTML={{
              __html:
                language === 'AZ'
                  ? data.description_az
                  : language === 'TR'
                  ? (data.description_tr || data.description_az)
                  : language === 'ENG'
                  ? data.description_eng
                  : (data.description_ru || data.description_az),
            }}
          />
        </div>
        <div className={styles.info}>
          <div>
            <Calendar /> <span>{new Date(data.date).toLocaleDateString()}</span>
          </div>
          <div>
            <Map /> <span>{data.location?.[language] || data.location?.TR || data.location?.AZ || ''}</span>
          </div>
          <div>
            <Call />
            <span>
              {data.phone && data.phone.map((item, idx) => (
                <a key={idx} href={`tel:${item}`}>{item}</a>
              ))}
            </span>
          </div>
        </div>
      </div>
      <Button to={`/vacancy-apply/${id}`}>
        {translate.apply_job?.[language] || translate.apply_job?.TR || translate.apply_job?.AZ || 'Müraciət et'}
      </Button>
    </section>
  ) : (
    <Loading />
  )
}

export default CareersInternal
